import { useEffect, useState } from "react";
import { Share, PlusSquare, X, Smartphone } from "lucide-react";

function isIOS() {
  const ua = window.navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
}

function isInStandaloneMode() {
  return (
    ("standalone" in window.navigator && window.navigator.standalone) ||
    window.matchMedia("(display-mode: standalone)").matches
  );
}

const DISMISS_KEY = "kn_ios_install_dismissed_at";
const RESHOW_DAYS = 7;

export default function IOSInstallPrompt() {
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!isIOS() || isInStandaloneMode()) return;
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    const days = (Date.now() - dismissed) / (1000 * 60 * 60 * 24);
    if (!dismissed || days > RESHOW_DAYS) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setShow(false);
  };

  return (
    <>
      <div className="ios-install-bar" data-testid="ios-install-bar">
        <div className="ios-install-icon"><Smartphone size={18} /></div>
        <div className="ios-install-text">
          <b>iPhone'a yükle</b>
          <small>Ana ekrana ekleyerek uygulamayı tek dokunuşla açın</small>
        </div>
        <button className="ios-install-btn" data-testid="ios-install-open" onClick={() => setExpanded(true)}>Nasıl?</button>
        <button className="ios-install-close" data-testid="ios-install-dismiss" onClick={dismiss} aria-label="Kapat"><X size={16} /></button>
      </div>

      {expanded && (
        <div className="ios-install-sheet-backdrop" data-testid="ios-install-sheet" onClick={() => setExpanded(false)}>
          <div className="ios-install-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="ios-install-sheet-head">
              <div>
                <span className="eyebrow"><span></span> iOS · SAFARI</span>
                <h2>Kemal Namlı Çiftliği'ni yükle</h2>
              </div>
              <button className="icon-btn" data-testid="ios-sheet-close" onClick={() => setExpanded(false)}><X size={19} /></button>
            </div>
            <p className="ios-sheet-lead">
              Uygulamayı iPhone ana ekranına ekleyin; simgesi Safari olmadan doğrudan açılır, tam ekran çalışır.
            </p>
            <ol className="ios-steps">
              <li>
                <span className="ios-step-num">1</span>
                <div>
                  <b>Safari'de bu sayfayı açın</b>
                  <small>(Chrome veya diğer tarayıcılarda çalışmaz)</small>
                </div>
              </li>
              <li>
                <span className="ios-step-num">2</span>
                <div>
                  <b>Alt çubukta <Share size={14} style={{ verticalAlign: -2, color: "#2563eb" }} /> Paylaş simgesine dokunun</b>
                  <small>(iPad'de sağ üstte)</small>
                </div>
              </li>
              <li>
                <span className="ios-step-num">3</span>
                <div>
                  <b>Listeden "Ana Ekrana Ekle" <PlusSquare size={14} style={{ verticalAlign: -2 }} /> seçin</b>
                  <small>Aşağı kaydırmanız gerekebilir</small>
                </div>
              </li>
              <li>
                <span className="ios-step-num">4</span>
                <div>
                  <b>Sağ üstte "Ekle" düğmesine dokunun</b>
                  <small>Simge ana ekranınıza gelir. Bundan sonra ondan açın.</small>
                </div>
              </li>
            </ol>
            <button className="primary-btn full" data-testid="ios-sheet-done" onClick={() => { dismiss(); setExpanded(false); }}>
              Tamam, anladım
            </button>
          </div>
        </div>
      )}
    </>
  );
}
